import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { authAPI } from '../actions/authActions';

export const ROLES = {
  SUPER_ADMIN:    'super_admin',
  COMPANY_ADMIN:  'company_admin',
  EDITOR:         'editor',
  VIEWER:         'viewer',
  LEADS_MANAGER:  'leads_manager',
};

export const ROLE_PERMISSIONS = {
  super_admin:   ['*'],
  company_admin: ['content.*', 'leads.*', 'media.*'],
  editor:        ['content.read', 'content.create', 'content.update', 'media.*'],
  viewer:        ['content.read', 'media.read'],
  leads_manager: ['leads.*', 'content.read'],
};

export function hasPermission(userRole, permission) {
  const perms = ROLE_PERMISSIONS[userRole] || [];
  if (perms.includes('*')) return true;
  if (perms.includes(permission)) return true;
  const [ns] = permission.split('.');
  return perms.includes(`${ns}.*`);
}

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user:   null,
      token:  null,
      isAuth: false,

      login: async ({ email, password }) => {
        const data = await authAPI.login({ email, password });
        localStorage.setItem('icon_auth_token', data.token);
        set({ user: data.user, token: data.token, isAuth: true });
      },

      logout: async () => {
        await authAPI.logout();
        localStorage.removeItem('icon_auth_token');
        set({ user: null, token: null, isAuth: false });
      },

      canAccess: (companyKey) => {
        const user = get().user;
        if (!user) return false;
        if (user.role === 'super_admin') return true;
        return user.companyAccess?.includes(companyKey);
      },
    }),
    {
      name: 'icon-admin-auth',
      partialize: (state) => ({
        user:   state.user,
        token:  state.token,
        isAuth: state.isAuth,
      }),
    }
  )
);
